import api from "../../API/apiConfig";

export const getTypePipeline = async (type) => {
  return await api.get(`/pipelines/${type}`);
};

export const addStage = async (stageName, pipelineId) => {
  return await api.post(`/pipelines/add-stage/${pipelineId}`, { stageName });
};

export const updateStage = async (id, stageName) => {
  return await api.put(`/pipelines/update-stage/${id}`, { stageName });
};

export const updateStageOrder = async (payload) => {
  return await api.put(`/pipelines/update-order`, payload);
};

export const deleteStage = async (id) => {
  return await api.delete(`/pipelines/delete-stage/${id}`);
};

export const addPipeline = async(params) => {
  return await api.post("/pipelines/add", params)
}

export const updatePipeline = async (id, data) => {
  return await api.put(`/pipelines/update/${id}`, data);
};

export const deletePipeline = async (id) => {
  return await api.delete(`/pipelines/delete/${id}`);
};

export const getPipeline = async (id) => {
  return await api.get(`/pipelines/detail/${id}`);
};

export const getAllPipelines = async () => {
  return await api.get("/pipelines/list");
};

export const usingPipeline = async (pipelineId, status) => { 
  return await api.put(`/pipelines/update-using/${pipelineId}?status=${status}`);
};